import React from "react";
import {Alert, Icon, Button, Input, Form, Modal} from "antd";
import get from "lodash/get";

import {DatafaxReprocessing, DatafaxOverwriteParticipantID, DatafaxCheckStatus, DatafaxPull} from "../../api/requests";

import classes from "./PatientProfileForm.css";
import { withNamespaces } from "react-i18next";
import {getFormErrorMessage} from "../../utils/errorHandler";

const statuses = {
  'completed': 'success',
  'declined': 'error',
  'error': 'error',
  'pending': 'warning',
  'idle': 'info',
};

class PatientDatafaxProcessing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
      isLoading: false,
      requestResult: null,
      isSentStatus: false,
      isSentPull: false,
      isLoadingStatus: false,
      isLoadingPull: false,
      requestResultStatus: null,
      requestResultPull: null,
      showOverwriteParticipantId: false,
      requestResultOverwriteParticipantId: null,
    };
  }

  handleSubmit = async () => {
    this.setState({ isLoading: true });
    try {
      const data = await DatafaxReprocessing(this.props.subjectID);

      this.setState({
        isSent: true,
        requestResult: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResult: {
          type: "error",
          message: "Error",
        },
      });
    }

    this.setState({ isLoading: false });
  };

  handleToggleOverwriteParticipantId = async () => {
    this.setState({ showOverwriteParticipantId: !this.state.showOverwriteParticipantId });
  };

  handleOverwriteParticipantID = async () => {
    this.setState({ isLoading: true });
    try {
      const data = await DatafaxOverwriteParticipantID(this.props.subjectID, this.props.form.getFieldValue("newParticipantId", null));

      this.setState({
        isSent: true,
        showOverwriteParticipantId: false,
        handleOverwriteParticipantID: true,
        requestResultOverwriteParticipantId: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResultOverwriteParticipantId: {
          type: "error",
          message: getFormErrorMessage(e),
        },
      });
    }

    this.setState({ isLoading: false });
  };


  handleSubmitPull = async () => {
    this.setState({ isLoadingPull: true });
    try {
      const data = await DatafaxPull(this.props.subjectID);

      this.setState({
        isSentPull: true,
        requestResultPull: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResultPull: {
          type: "error",
          message: this.props.i18n.t("Error"),
        },
      });
    }

    this.setState({ isLoadingPull: false });
  };

  handleSubmitCheckStatus = async () => {
    this.setState({ isLoadingStatus: true });
    try {
      const data = await DatafaxCheckStatus(this.props.subjectID);

      this.setState({
        isSentStatus: true,
        requestResultStatus: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResultStatus: {
          type: "error",
          message: this.props.i18n.t("Error"),
        },
      });
    }

    this.setState({ isLoadingStatus: false });
  };

  render() {
    const {} = this.props;

    const {
      isLoading,
      isSent,
      requestResult,
      isLoadingStatus,
      isLoadingPull,
      isSentStatus,
      isSentPull,
      requestResultStatus,
      requestResultOverwriteParticipantId,
      requestResultPull,
    } = this.state;

    return (
      <div className={classes.patientProfileForm}>
        <div>
          {this.state.showOverwriteParticipantId && <div>

            <Modal
              visible={true}
              width={767}
              onCancel={() =>
                this.setState({
                  modalMilestoneVisible: false
                })
              }
              footer={null}
            > <Alert
              message={this.props.i18n.t("Warning! This action will attempt to update the participant_id field for this subject in api connections, " +
                "randomization form, and consent records. Changing this value to an incorrect one can cause the api to function incorrectly." +
                "This action will NOT push or pull any data for the new participant_id. \n" +
                " Please use with caution. Confirm the Participant ID is correct. This action will be recorded.")} type="warning"
              style={{maxWidth: '700px', width: '100%'}}/> <Form
              onSubmit={this.handleOverwriteParticipantID}> <Form.Item>
              {this.props.form.getFieldDecorator("newParticipantId", {
                initialValue: '',
                rules: [
                  {
                    required: false,
                    message: this.props.i18n.t("Required"),
                  },
                ],
              })(
                <Input
                  autoComplete="off"
                  id="newParticipantId"
                  name="newParticipantId"
                  placeholder={this.props.i18n.t("New Participant ID")}
                  allowClear
                  size="large"
                  data-lpignore="true"
                />
              )}
              <br/><br/> {requestResultOverwriteParticipantId && requestResultOverwriteParticipantId.type &&
              <Alert message={requestResultOverwriteParticipantId.message}
                     type={statuses[requestResultOverwriteParticipantId.type]}
                     style={{width: '600px'}}/>
                }
            <br/>

              <div className={classes.actionWrapper}>
                <Button
                  disabled={isSent}
                  type="warning"
                  size="large"
                  htmlType="button"
                  onClick={this.handleOverwriteParticipantID}
                  className={classes.submitButtonRed}
                >
                  {this.props.i18n.t('NamespacePatientAPIControls:Save New Participant ID')}
                </Button>

                <Button
                  disabled={isSent}
                  type="default"
                  size="large"
                  htmlType="button"
                  onClick={this.handleToggleOverwriteParticipantId}
                  style={{float: "right", marginLeft: "auto"}}
                  className={classes.submitButton}
                >
                  {this.props.i18n.t('NamespacePatientAPIControls:Cancel')}
                </Button>

              </div>

            </Form.Item> </Form>
      </Modal>
  </div>
  } {
    !this.state.showOverwriteParticipantId && <div>
      <Button
        disabled={isSent}
        type="default"
        size="small"
        htmlType="button"
        onClick={this.handleToggleOverwriteParticipantId}
      >
        {this.props.i18n.t('NamespacePatientAPIControls:Change DFNet participant ID')} {isLoading &&
            <Icon type="loading"/>}
          </Button>
        </div>
        }
        <br/><br/>
          {requestResultOverwriteParticipantId && requestResultOverwriteParticipantId.type &&
            <Alert message={requestResultOverwriteParticipantId.message}
                   type={statuses[requestResultOverwriteParticipantId.type]}
                   style={{width: '300px'}}/>
          }
        </div>

        <br/>

        <div>
          <Button
            disabled={isSentStatus}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmitCheckStatus}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientAPIControls:DFDiscover Check Status')} {isLoadingStatus &&
            <Icon type="loading"/>}
          </Button> <br/><br/> {requestResultStatus && requestResultStatus.type &&
          <Alert message={requestResultStatus.message} type={statuses[requestResultStatus.type]}
                 style={{width: '300px'}}/>
        }
        </div>

        <br/>
        <div>
          <Button
            disabled={isSent}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmit}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientAPIControls:DFDiscover Push Subject')} {isLoading &&
            <Icon type="loading"/>}
          </Button> <br/><br/> {requestResult && requestResult.type &&
          <Alert message={requestResult.message} type={statuses[requestResult.type]}
                 style={{width: '300px'}}/>
        }
        </div>


        <br/>


        <div>
          <Button
            disabled={isSentPull}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmitPull}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientAPIControls:DFDiscover Pull subject')} {isLoadingPull &&
            <Icon type="loading"/>}
          </Button> <br/><br/> {requestResultPull && requestResultPull.type &&
          <Alert message={requestResultPull.message} type={statuses[requestResultPull.type]}
                 style={{width: '300px'}}/>
        }
        </div>

      </div>
    );
  }
}

export default Form.create({name: "dfnetForm"})(
  withNamespaces()(PatientDatafaxProcessing)
);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientDatafaxProcessing.js